module.exports = __webpack_public_path__ + "static/media/grayscale.0f80f8be.jpg";